import React from "react";
import { CircleTickIcon } from "./svg-icons";

const FormSubmitSuccess = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center py-20">
      <div className="mx-auto mb-4 flex justify-center">
        <CircleTickIcon />
      </div>
      <div className="text-center">
        <h3 className="mb-2 text-xl font-medium text-system-crystalWhite">
          Thank you for signing up!
        </h3>
        <p className="text-sm text-system-disabled sm:text-[15px] md:text-base">
          We appreciate your interest. You&apos;ll hear from us soon with more details.
        </p>
      </div>
    </div>
  );
};

export default FormSubmitSuccess;
